import * as types from './mutation_types'
import cookies from '@/services/cookies'
import api from '@/api'
import apiAuth from '@/api/auth'

export default {
  // TODO А оно надо тут? В экшене нигде не используется, нужно либо почистить, либо сделать чтобы авторизация через него шла
  LOGIN: (state, authResult) => {
    const curTime = Date.now()

    authResult.expiresAt = (authResult.expiresIn || 0) * 1000 + curTime
    state.authResult = authResult

    window.localStorage.setItem('authResult', JSON.stringify(authResult))
  },

  [types.LOGOUT]: (state, { withoutLogoutRequest = false }) => {
    if (!withoutLogoutRequest) {
      try {
        apiAuth.logout()
      } catch (error) {}
    }

    /**
     * Чистим стор
     */
    const localStorageItems = [
      'addresses',
      'profile',
      'activeOrders',
      'client_token',
    ]
    localStorageItems.forEach((item) => {
      window.localStorage.removeItem(item)
    })

    /**
     * Делитаем куку
     */
    cookies.remove('client_token')

    /**
     * Чистим стор
     */
    state.token = null
    state.profile = null
    state.menu_plans = null
    state.addresses = null
    state.faq = null
    state.unauthorizedImtData = {}

    api.removeToken()
  },

  [types.SET_CLIENT]: (state, data) => {
    if (data === null) {
      state.profile = null
      window.localStorage.removeItem('profile')
      return
    }
    if (data && data.profile) {
      state.profile = data.profile
      window.localStorage.setItem('profile', JSON.stringify(data.profile))
    } else {
      state.profile = data
      window.localStorage.setItem('profile', JSON.stringify(data))
    }
  },

  [types.SET_CLIENT_TOKEN]: (state, token) => {
    window.localStorage.setItem('client_token', token)
    cookies.set('client_token', token)
    api.setToken(token)

    state.token = token || null
  },

  /**
   * @param {number} amount
   */
  CHANGE_USER_BALANCE: (state, amount) => {
    const balance = state.user.balance
    state.user.balance = balance - amount
  },

  SET_FAQ: (state, data) => {
    console.log('mutations faq', data)
    state.faq = data
  },

  SET_MENU_PLANS: (state, data) => {
    state.menu_plans = data
  },

  SET_DEMO_MODE: (state, value) => {
    state.demo_mode = value
  },

  SET_ADDRESSES: (state, addresses) => {
    state.addresses = addresses

    window.localStorage.setItem('addresses', JSON.stringify(state.addresses))
  },

  ADD_OR_UPDATE_ADDRESS: (state, address) => {
    const index = state.addresses.findIndex(
      (value) => value.id_H === address.id_H,
    )
    if (index) {
      state.addresses[index] = address
    } else {
      state.addresses.push(address)
    }

    window.localStorage.setItem('addresses', JSON.stringify(state.addresses))
  },

  [types.SET_UNAUTHORIZED_IMT_DATA] (state, imtData) {
    state.unauthorizedImtData = imtData
  },
  [types.SET_CLIENT_LAST_FILTER_IDS] (state, newLastFilterIds) {
    state.profile.lastFilterIds = newLastFilterIds
  },
  [types.SET_CLIENT_TOURS] (state, newTour) {
    state.profile.toursViewed = [...state.profile.toursViewed, newTour]
  },

  [types.SET_PRELOADED_MENUS] (state, value) {
    state.preloadedMenus = value
  },
}
